<style lang="stylus">
    .font-tool {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        column-gap: 8px;
        justify-content space-between
        align-items: center;
        user-select: none;
        .font-selecter{
            float: left;
            position: relative;
            width: 130px;
            height: 28px;
            border-radius: 3px;
            box-sizing: border-box;
            background-color: var(--bg-color-tertiary);
            margin-right: 6px;

            .font-name{
                height: 24px;
                text-indent: 6px;
                // width: 110px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                line-height: 22px;
                cursor: pointer;
                padding-right: 20px;
            }


            .font-list{
                background-color: var(--bg-color-tertiary);
                box-shadow: $common-box-shadow;
                height: 400px;
                overflow: auto;

                li{
                    list-style: none;
                    padding: 5px 0;
                    padding-left: 10px;
                    user-select: none;
                    cursor: pointer;
                        &:hover{
                            background-color: var(--bg-color-font-list-item-hover);
                        }
                }
            }
            .down-arrow{
                position: absolute;
                right: 8px;
                top: 11px;
                width: 8px;
                height: 4px;
                color: var(--svg-color-primary)

                &:hover{
                    cursor: pointer;
                }
            }

        }

        .font-btn{
            float: left;
            position: relative;
            width: 24px;
            height: 24px;
            margin-left: 12px;
            cursor: pointer;
            user-select: none;
            border-radius: $common-border-radius;

            .item-arrow{
                position: absolute;
                left: 0;
                top: 0;
                width: 22px;
                height: 22px;
            }
            .item-icon{
                pointer-events: none;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%,-50%);
                width: 20px;
                height: 20px;
                color: var(--svg-color-primary-secondary);
                &.noteImageInsIcon {
                    color: var(--svg-color-primary-secondary);
                    fill: var(--svg-color-gray-75-secondary);
                }
            }
            .item-color{
                position: absolute;
                left: -6px;
                bottom: 1px;
                width: 16px;
                height: 3px;
                border-radius: 2px;
            }
            &.active{
                background-color: $main-selectcolor;
            }
            &:hover:not(.active){
                background-color: $main-hovercolor;
            }

            .font-btn-arrow{
                position: absolute;
                right: 0;
                bottom: 0;
            }

            .aroundbox-list{
                width: 167px;
                height: 180px;
                padding: 8px 10px;
                margin-top: 13px;
                background-color: $navigation-modal-bgcolor;
                border-radius: 5px;
                box-shadow: $common-box-shadow
                box-sizing: border-box;
                z-index: 1;

                .aroundbox-li{
                    float: left;
                    list-style: none;
                    width: 33px;
                    height: 33px;
                    box-sizing: border-box;
                    user-select: none;
                    cursor: pointer;
                    margin-right: 5px;

                    &:nth-child(4n){
                        margin-right: 0;
                    }

                    &:not(.ban-btn):hover{
                        background-color: #ddd;
                    }


                    .item-icon{
                        margin: 3px;
                            width: 27px;
                            height: 27px;
                    }
                }

                .roundbox-clean{
                    float: left;
                    width: 100%;
                    height: 24px;
                    line-height: 24px;
                    margin-top: 10px;
                    border-top: 1px solid #ddd;
                    user-select: none;
                    cursor: pointer;
                    &:not(.ban-btn)hover{
                        background-color: #ddd;
                    }
                }

                .ban-btn{
                    opacity: .2;
                    cursor: not-allowed;
                }
            }

        }


        .down-arrow-container {
            display: inline-block;
            position: absolute;
            right: 0;
            width: 16px;
            height: 26px;
            border-left: 1px solid white;
            &:hover {
                border-left-color: #4c4c4c;
            }
            svg {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 10px;
                height: 10px;
            }
        }
        .menu-item {
            &:hover {
                background-color: #96bef8;
            }
        }
        .activedBtn {
            background-color: #d2d0ce;
        }
        .activedDrop {
            background-color: #c4c4c4 !important;
        }
        .switchBtn {
            width: 25px;
            height: 25px;
            margin: 0 4px;
            .item-icon{
                width: 20px;
                height: 20px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            > img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            &:hover:not(.active){
                background-color: $main-hovercolor;
            }
        }
        .drop-btn {
            width: 32px;
            height: 24px;
            border-radius: $common-border-radius;
            position: relative;
            .drop-mask {
                width: 100%;
                height: 100%;
            }
            .drop-div {
                margin-top: 5px;
                margin-left: 5px;
                width: 18px;
                height: 14px;
            }
            >.item-icon{
                width: 20px;
                height: 20px;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-70%, -50%);
                color: var(--svg-color-primary-secondary);
            }
            .item-color{
                position: absolute;
                left: 7px;
                bottom: 4px;
                width: 18px;
                height: 3px;
            }
            > img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-70%, -50%);
            }
            > svg {
                pointer-events: none;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(100%, -50%);
            }
            .simpledrop-def-svg {
                width: 8px;
                height: 4px;
                color: var(--svg-color-primary);
            }
            &:hover:not(.active){
                background-color: $main-hovercolor;
            }
            .drop-TP {
                width: 50px;
                height: 50px;
                > img {
                    width: 100%;
                    height: 100%;
                    &:hover {
                        background-color: #e5e5e5;
                    }
                }
            }
            .drop-TPContainer {
                position: fixed;
                display: flex;
                flex-wrap: wrap;
                right: 0;
                background-color: white;
                border: 1px solid #bcbcbc;
                width: 202px;
                height: 202px;
            }
            .drop-AL {
                width: 50px;
                height: 50px;
                position: relative;
                &:hover {
                        background-color: #e5e5e5;
                }
                >img {
                    position: absolute;
                    width: 80%;
                    height: 80%;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);

                }
            }
            .drop-ALContainer {
                            width: 120px;
                            padding: 8px 10px;
                            margin-top: 3px;
                            background-color: $navigation-modal-bgcolor;
                            border-radius: 5px;
                            box-shadow: $box-shadow;
                            box-sizing: border-box;
                            z-index: 1;
                            overflow: hidden;

                            .imgbox-li{
                                float: left;
                                list-style: none;
                                width: 30px;
                                height: 30px;
                                box-sizing: border-box;
                                user-select: none;
                                cursor: pointer;
                                margin-right: 5px;
                                position: relative;

                                &:nth-child(3n){
                                    margin-right: 0;
                                }

                                &:hover{
                                    background-color: $main-hovercolor
                                }

                                .item-icon{
                                    width: 30px;
                                    height: 30px;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    color: var(--svg-color-gray-42-secondary);
                                }

                            }


            }
            .drop-BT {
                width: 50px;
                height: 50px;
                position: relative;
                &:hover {
                        background-color: #e5e5e5;
                }
                >img {
                    position: absolute;
                    width: 80%;
                    height: 80%;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);

                }
            }
            .drop-BTContainer {
                position: fixed;
                box-shadow: $box-shadow;
                z-index: 1;
                border-radius 6px
                @media screen and (max-width: 878px){
                    right 0
                }
                .liststylemodal{
                    border-radius 6px
                    ul{
                        padding 16px
                        width 168px
                        height 168px
                        background $ft-bgcolor
                        border-radius 6px
                        box-shadow var(--box-shadow-color-expand-drop)
                        list-style none
                        display grid
                        grid-template-columns repeat(3, 1fr)
                        grid-gap 8px;

                        li{
                            width: 40px;
                            height: 40px;
                            position: relative;

                            &:hover, &.active {
                                background-color transparent
                            }
                            &.active {
                                .border {
                                    border: 2px solid var(--themeColor)
                                }
                            }
                            .border {
                                width: 40px;
                                height 40px;
                                position absolute
                                top 0;
                                left 0;
                                border-radius 6px;
                                border: 1px solid var(--border-color-box-8)
                            }
                            .item-icon{
                                width: 40px;
                                height: 40px;
                            }

                        }

                    }

                }

            }
            .drop-LS{
                width: 100px;
                height: 24px;
                line-height: 24px;
                position: relative;
                text-indent: 20px;
                &:hover {
                        background-color: #e5e5e5;
                }
            }
            .activedLS::before{
                content: '\2713';
                position: absolute;
                left: 8px;
                text-indent: 0;
            }
            .drop-LSContainer{
                position: fixed;
                background-color: white;
                border: 1px solid #bcbcbc;
                width: 100px;
                height: 146px;
            }
        }
        .note-font-family{
            width: 150px !important;
            .font-family-menu{
                width: 150px !important;
            }
        }
        .note-font-size{
            width: 80px !important;
            .font-size-menu{
                width: 80px !important;
            }
        }

        .font-family {
            display: inline-block;
            position: relative;
            width: 185px;
            height: 28px;
            border: 1px solid #bebebe;
            border-radius: 3px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            &:hover {
                border-color: #4c4c4c;
            }
            .font-family-title {
                display: flex;
                height: 25px;
            }
            .font-family-input {
                border: none;
                outline: none;
                width: 100%;
                margin: 2px;
            }
            .font-family-menu {
                overflow-y: scroll;
                overflow-x: hidden;
                width: 185px;
                height: 240px;
                position: fixed;
                z-index: 101;
                background-color: white;
                border: 1px solid #828790;
            }
        }
        .font-size {
            display: inline-block;
            position: relative;
            border: 1px solid #bebebe;
            border-left: none;
            border-radius: 3px;
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            width: 65px;
            height: 28px;
            &:hover {
                border-color: #4c4c4c;
            }
            .font-size-title {
                display: flex;
                height: 25px;
            }
            .font-size-input {
                border: none;
                outline: none;
                width: 27px;
                margin: 2px;
            }
            .font-size-menu {
                overflow-y: scroll;
                overflow-x: hidden;
                width: 65px;
                height: 120px;
                position: fixed;
                z-index: 101;
                background-color: white;
                border: 1px solid #828790;
            }
        }
        .ivu-tooltip-rel{
            display: block;
        }
        .separate-line{
            width: 1px;
            height: 16px;
            margin: 4px 0;
            background-color: #aaa;
        }
    }
</style>

<template>
    <div class="font-tool">
        <div class="mask" v-show="masked"></div>
        <div id="familyName" class="font-selecter">
            <p class="font-name" v-text="activedFamily" @click.stop="showFamilyName()"></p>
            <ul class="font-list" v-click-outside="closeFamily" v-show="showFamilyList">
                <li v-for="(item, index) in family" :key="index" :style="{ fontFamily: item }" @click="clickFamilyList(index)">{{ item }}</li>
            </ul>
            <iconSymbol class="down-arrow" :name="'downArrow'" @click.native.stop="showFamilyName()"></iconSymbol>
        </div>
        <div id="sizeName" class="font-selecter" style="width: 70px">
            <p class="font-name" v-text="activedSize" @click.stop="showSizeName()"></p>
            <ul class="font-list" v-click-outside="closeSize" v-show="showSizeList">
                <li v-for="(item, index) in size" :key="index" @click="clickSizeList(index)">{{ item }}</li>
            </ul>
            <iconSymbol class="down-arrow" :name="'downArrow'" @click.native.stop="showSizeName()"></iconSymbol>
        </div>

        <div class="font-btn" :class="{ active: bold }" @click.stop="clickBtn('bold')">
            <iconSymbol class="item-icon" :name="'bold'"></iconSymbol>
        </div>
        <div class="font-btn" :class="{ active: italic }" @click.stop="clickBtn('italy')">
            <iconSymbol class="item-icon" :name="'italy'"></iconSymbol>
        </div>
        <div class="font-btn" :class="{ active: underline }" @click.stop="clickBtn('underline')">
            <iconSymbol class="item-icon" :name="'underline'"></iconSymbol>
        </div>
        <div class="font-btn" :class="{ active: strike }" @click.stop="clickBtn('strikethrough')">
            <iconSymbol class="item-icon" :name="'delline'"></iconSymbol>
        </div>
        <div class="font-btn" @click.stop="showFontColor($event)">
            <iconSymbol style="top: 48%" class="item-icon" :name="'fontcolorA'"></iconSymbol>
            <div :style="{ backgroundColor: fontColor }" class="item-color"></div>
        </div>
        <div @click.stop="showBackColor($event)" class="font-btn">
            <!-- <img :src="require('@/app/assets/img/font/backClr.png')"> -->
            <iconSymbol class="item-icon" name="backgroundcolor" />
            <div :style="{ backgroundColor: backColor }" class="item-color"></div>
        </div>
        <!-- <div class="font-family" :class='{"note-font-family": isEditNote}'     ref="family">
            <div class="font-family-title">
                <input class="font-family-input" autocomplete="off" type="text" v-model="activedFamily">
                <div class="down-arrow-container" @click.stop="toShow('family')">
                    <iconSymbol :name="'TriDown'"></iconSymbol>
                </div>
            </div>
            <div class="font-family-menu" v-click-outside="closeFamily" v-show="showState.family">
                <div
                    class="menu-item"
                    v-for="item in family"
                    :key="item.id"
                    :style="{fontFamily:item}"
                    @click="editStyle($event,'family',item)"
                >{{item}}</div>
            </div>
        </div> -->
        <!-- <div class="font-size" :class='{"note-font-size": isEditNote}' ref="size">
            <div class="font-size-title">
                <input class="font-size-input" autocomplete="off" type="text" v-model="activedSize">
                <div class="down-arrow-container" @click.stop="toShow('size')">
                    <iconSymbol :name="'TriDown'"></iconSymbol>
                </div>
            </div>
            <div class="font-size-menu" v-click-outside="closeSize" v-show="showState.size">
                <div
                    class="menu-item"
                    v-for="item in size"
                    :key="item.id"
                    @click="editStyle($event,'size',item)"
                >{{item}}</div>
            </div>
        </div>
        <Tooltip content="Bold">
            <div class="switchBtn" :class="{activedBtn:bold}" @click="toggle('bold')">
                <!-- <img :src="require('@/app/assets/img/font/bold.png')"> -->
        <!-- <iconSymbol class="item-icon" name="note-bold" />
            </div> -->
        <!-- </Tooltip>
        <Tooltip content="Italic">
            <div class="switchBtn" :class="{activedBtn:italic}" @click="toggle('italy')">
                <!-- <img :src="require('@/app/assets/img/font/italic.png')"> -->
        <!-- <iconSymbol class="item-icon" name="note-italy" />
            </div> -->
        <!-- </Tooltip>
        <Tooltip content="Underline">
            <div class="switchBtn" :class="{activedBtn:underline}" @click="toggle('underline')">
                <iconSymbol class="item-icon" name="note-underline" />
                <!-- <img :src="require('@/app/assets/img/font/underline.png')"> -->
        <!-- </div> -->
        <!-- </Tooltip>
        <Tooltip content="StrikeThrough">
            <div class="switchBtn" :class="{activedBtn:strike}" @click="toggle('strikethrough')">
                <iconSymbol class="item-icon" name="note-deleteline" />
                <!-- <img :src="require('@/app/assets/img/font/strike.png')"> -->
        <!-- </div> -->
        <!-- </Tooltip> -->
        <!-- <Tooltip content="Plus" v-if='!isEditNote'>
            <div class="switchBtn" @click="toggle('increaseSize')">
                <img :src="require('@/app/assets/img/font/sizeup.png')">
            </div>
        </Tooltip>
        <Tooltip content="Minus" v-if='!isEditNote'>
            <div class="switchBtn" @click="toggle('decreaseSize')">
                <img :src="require('@/app/assets/img/font/sizedown.png')">
            </div>
        </Tooltip> -->
        <!-- <div @click="toggleShow('textPath')" v-if='!isEditNote' v-click-outside="closeShowPath" class="drop-btn">
            <div class="drop-mask"></div>
            <img :src="require('@/app/assets/img/font/textPath.png')">
            <iconSymbol class="simpledrop-def-svg" :name="'downArrow'"></iconSymbol>
            <div v-show="showTextPath" class="drop-TPContainer">
                <div class="drop-TP" @click.stop="setType('textPath',n)" v-for="n in 15">
                    <img :src="require('@/app/assets/img/font/tp'+n+'.png')">
                </div>
            </div>
        </div> -->
        <div @click="toggleShow('align')" v-click-outside="closeAlign" class="drop-btn">
            <div class="drop-mask"></div>
            <!-- <img :src="require('@/app/assets/img/font/align.png')"> -->
            <iconSymbol class="item-icon" name="fontalign" />
            <iconSymbol class="simpledrop-def-svg" :name="'downArrow'"></iconSymbol>
            <!-- <div v-show="showAlign" class="">
                <div class="drop-AL" :class="{activedDrop: textAlign === n}" @click.stop="setType('align',n)" v-for="n in 12">
                    <img :src="require('@/app/assets/img/font/al'+n+'.png')">
                </div>
            </div> -->
            <ul class="drop-ALContainer" v-show="showAlign">
                <li class="imgbox-li" v-for="item in fontAlignList" :key="item.id" @click.stop="clickAlign(item.id)">
                    <iconSymbol class="item-icon" :name="item.name"></iconSymbol>
                </li>
            </ul>
        </div>
        <div @click="toggleShow('bullet')" v-click-outside="closeBullet" class="drop-btn">
            <div class="drop-mask"></div>
            <!-- <img :src="require('@/app/assets/img/font/bullet.png')"> -->
            <iconSymbol class="item-icon" name="new-liststyle" />
            <iconSymbol class="simpledrop-def-svg" :name="'downArrow'"></iconSymbol>
            <div v-show="showBullet" class="drop-BTContainer">
                <!-- <div class="drop-BT" @click.stop="setType('bullet',n)" v-for="n in 19">
                    <img :src="require('@/app/assets/img/font/bt'+n+'.png')">
                </div> -->
                <div class="liststylemodal">
                    <ul>
                        <li v-for="item in listStyleList" :key="item.id" @click.stop="clickListStyle(item.id)">
                            <iconSymbol class="item-icon" :name="`${item.name}${isDarkTheme() ? '-dark' : ''}`"></iconSymbol>
                            <div class="border"></div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <label class="font-btn" for="noteInputImg">
            <iconSymbol class="item-icon noteImageInsIcon" :name="'noteImageInsIcon'"></iconSymbol>
        </label>
        <input style="display: none" id="noteInputImg" accept=".png,.jpg" type="file" @change="insertImg" />
        <!-- <div @click="toggleShow('lineSpace')" v-if='!isEditNote' v-click-outside="closeLineSpace" class="drop-btn">
            <div class="drop-mask"></div>
            <img :src="require('@/app/assets/img/font/lineSpace.png')">
            <iconSymbol class="item-icon" name="note-lineheight" />
            <iconSymbol class="simpledrop-def-svg" :name="'downArrow'"></iconSymbol>
            <div v-show="showLineSpace" class="drop-LSContainer">
                <div class="drop-LS" :class="{activedLS:lineSpace === n}" @click.stop="setType('lineSpace',n)" v-for="n in 6" v-text='getLSText(n)'>
                </div>
            </div>
        </div> -->
        <!-- <div class="separate-line"></div> -->

        <!-- <div @click.stop="showFontColor($event)" class="drop-btn">
            <div class="drop-div" :style="{'background-color': fontColor}"></div>
            <iconSymbol class="simpledrop-def-svg" :name="'TriDown'"></iconSymbol>
        </div> -->
        <!-- <SimpleButton class='font-button' :funcName='FuncNames.Plus' />
 <SimpleButton class='font-button' :funcName='FuncNames.Minus'/>
 <SimpleDrop :type="'down2'" :showText='false' :funcName='FuncNames["Text Align"]' />
    <SimpleDrop :type="'down2'" :showText='false' :funcName='FuncNames["Text on Path"]' />
    <SimpleButton class='font-button' :funcName='FuncNames.Bold'/>
     <SimpleButton class='font-button' :funcName='FuncNames.Italic'/>
        <SimpleButton class='font-button' :funcName='FuncNames.Underline'/>
         <SimpleButton class='font-button' :funcName='FuncNames.Strikethrough'/>
         <SimpleButton class='font-button' :funcName='FuncNames.Subscript'/>
         <SimpleButton class='font-button' :funcName='FuncNames.Supscript'/>
         <SimpleDrop :showText='false' :funcName='FuncNames["Line Spacing"]' />
        <SimpleDrop :type="'down2'" :showText='false' :funcName='FuncNames.Bullets' />-->
    </div>
</template>
<script lang="ts">
    declare var TextEditor: any;
    declare var UnitUtil: any;
    declare var eUnit: any;
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";

    @Component({})
    export default class Font extends Vue {
        @Inject()
        ["showMessage"];
        @Prop(String) readonly from!: string;
        showState = {
            family: false,
            size: false,
        };
        showTextPath: boolean = false;
        showAlign: boolean = false;
        showBullet: boolean = false;
        showLineSpace: boolean = false;
        fontAlignList: Array<object> = [
            {
                id: 0,
                text: "",
                name: "topleft",
            },
            {
                id: 1,
                text: "",
                name: "topcenter",
            },
            {
                id: 2,
                text: "",
                name: "topright",
            },
        ];
        get listStyleList() {
            return [
                {
                    id: 0,
                    text: "",
                    name: this.lang === "zh" ? "new-liststyle-1-zh" : "new-liststyle-1-cn",
                },
                {
                    id: 1,
                    text: "",
                    name: "new-liststyle-2",
                },
                {
                    id: 2,
                    text: "",
                    name: "new-liststyle-3",
                },
                {
                    id: 3,
                    text: "",
                    name: "new-liststyle-4",
                },
                {
                    id: 4,
                    text: "",
                    name: "new-liststyle-5",
                },
                {
                    id: 5,
                    text: "",
                    name: "new-liststyle-6",
                },
                {
                    id: 6,
                    text: "",
                    name: "new-liststyle-7",
                },
                {
                    id: 7,
                    text: "",
                    name: "new-liststyle-8",
                },
                {
                    id: 8,
                    text: "",
                    name: "new-liststyle-9",
                },
            ];
        }
        size: number[] = [6, 7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];
        family: string[] = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
            "仿宋",
            "楷书",
            "隶书",
            "微软雅黑",
            "黑体",
            "宋体",
            "华文楷体",
            "华文行楷",
            "华文新魏",
        ];
        enFamily: string[] = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
        ];
        zhFamily: string[] = ["仿宋", "楷书", "隶书", "微软雅黑", "黑体", "宋体", "华文楷体", "华文行楷", "华文新魏"];
        currentFamily: string = this.family[0];
        currentSize: number = this.size[4];
        showFamilyList: boolean = false;
        showSizeList: boolean = false;
        activedFamily: string = "Arial";
        activedSize: number = 10;
        bold: boolean = false;
        italic: boolean = false;
        underline: boolean = false;
        strike: boolean = false;
        fontColor: string = "#000000";
        backColor: string = "#000000";

        getStyle() {
            let style;
            if (this.$store.state.dialog.showDialog && this.$store.state.dialog.dialogType === "note") {
                let noteDiv = document.getElementById("edNoteEditDiv");
                style = TextEditor.getCaretStyle(noteDiv);
            }
            if (style) {
                this.activedFamily = style.family && style.family.replace(/\"/g, "");
                this.activedSize = style.size;
                this.bold = style.bold;
                this.italic = style.italic;
                this.underline = style.underline;
                this.strike = style.strike;

                this.fontColor = style.color;
                this.backColor = style.backClr;
            }
        }
        showFamilyName() {
            this.showFamilyList = !this.showFamilyList;
            this.showSizeList = false;
        }
        showSizeName() {
            this.showSizeList = !this.showSizeList;
            this.showFamilyList = false;
        }
        clickFamilyList(index) {
            if (this.isEditNote) this.$emit("addStack");
            this.showFamilyList = false;
            this.activedFamily = this.family[index].replace(/\"/g, "");
            // let payload = {
            //         type: "family",
            //         data:
            // };
            // this.$store.commit("setFontFmtData", payload);
            this.editStyles("family", this.family[index]);
        }
        editStyles(type: any, styles?: any) {
            let editDiv = <HTMLDivElement>document.getElementById("edNoteEditDiv");
            let processor = TextEditor.createSpanStyleProcess(type, styles);
            if (type === "align") {
                TextEditor.editAlign(editDiv, null, styles);
            } else if (type === "lineHeight") {
                TextEditor.editLineHeight(editDiv, styles);
            } else if (type === "bullet") {
                TextEditor.editBullet(editDiv, styles);
            } else {
                TextEditor.processSpanStyle(processor, editDiv);
            }

            if (this.isEditNote) {
                document.getElementById("edNoteEditDiv").focus();
            }
        }
        clickSizeList(index) {
            if (this.isEditNote) this.$emit("addStack");
            this.showSizeList = false;

            let minFontPx = getComputedStyle(window["_view"]._measureMinFontSizeEle).fontSize.slice(0, -2);
            let minFontPt = UnitUtil.pixelToUnit(minFontPx, eUnit.pt);
            if (this.size[index] < minFontPt) {
                let ts = this as any;
                ts.showMessage({
                    type: 2,
                    content: ts.$t("msgContent") + minFontPt + ts.$t("msgContent2"),
                });
                return;
            }
            this.activedSize = this.size[index];
            this.editStyles("size", this.size[index]);
        }
        clickListStyle(index) {
            if (this.isEditNote) this.$emit("addStack");
            this.closeBullet();
            this.editStyles("bullet", index);
        }
        clickAlign(index) {
            if (this.isEditNote) this.$emit("addStack");
            this.closeAlign();
            let alignText = [
                ["left", "top"],
                ["center", "top"],
                ["right", "top"],
            ];
            this.editStyles("align", alignText[index]);
        }
        insertImg(e: MouseEvent) {
            let view = window["_view"];
            if (!(<HTMLInputElement>e.srcElement).files.length || !view) return;
            let file = (<HTMLInputElement>e.srcElement).files[0];
            let blob = new Blob([file], { type: file.type });
            view.insertImgtoNote(blob);
            (document.querySelector("#noteInputImg") as HTMLInputElement).value = "";

            //     let name = "media/" + file.name;
            // let imgWidth = img.naturalWidth;
            // let imgHeight = img.naturalHeight;
            // if (imgWidth > 200 || imgHeight > 120) {
            // 	let scale = Math.max(200 / imgWidth, 120 / imgHeight);
            // 	imgWidth = Math.round(imgWidth * scale);
            // 	imgHeight = Math.round(imgHeight * scale);

            // 	this.compressImage(img, imgWidth, imgHeight).then((blob: Blob) => {
            // 		//压缩后的blob
            // 		this.processBlob(blob, name, imgWidth, imgHeight);
            // 	});
            // } else {
            // 	let blob = new Blob([file], { type: file.type }); //原始blob
            // 	this.processBlob(blob, name, imgWidth, imgHeight);
            // }

            // view.insertImageFromFile((<HTMLInputElement>e.srcElement).files);
        }
        clickBtn(type: string) {
            if (this.isEditNote) this.$emit("addStack");
            switch (type) {
                case "bold": {
                    this.bold = !this.bold;
                    this.editStyles(type, this.bold);
                    break;
                }
                case "italy": {
                    this.italic = !this.italic;
                    this.editStyles(type, this.italic);
                    break;
                }
                case "underline": {
                    this.underline = !this.underline;
                    this.editStyles(type, this.underline);
                    break;
                }
                case "strikethrough": {
                    this.strike = !this.strike;
                    this.editStyles(type, this.strike);
                    break;
                }
                default: {
                    break;
                }
            }
        }
        getLSText(i: number): string {
            if (i === 1) {
                return "1.0";
            } else if (i === 2) {
                return "1.2";
            } else {
                return (i * 0.5).toFixed(1);
            }
        }
        toggleShow(type: string) {
            if (type === "textPath") {
                this.showTextPath = !this.showTextPath;
            } else if (type === "align") {
                this.showAlign = !this.showAlign;
            } else if (type === "bullet") {
                this.showBullet = !this.showBullet;
            } else if (type === "lineSpace") {
                this.showLineSpace = !this.showLineSpace;
            }
        }
        closeShowPath() {
            this.showTextPath = false;
        }
        closeAlign() {
            this.showAlign = false;
        }
        closeBullet() {
            this.showBullet = false;
        }
        closeLineSpace() {
            this.showLineSpace = false;
        }
        toggle(type: string) {
            let view = window["_view"];
            this.editStyles(type);
        }
        // setType(type: string, data: number) {
        //     if (type === "textPath") {
        //         this.editStyles("textOnPath", data - 1);
        //         this.closeShowPath();
        //     }else if(type === 'align'){
        //         const alignText = [
        // 			['left','top'],['center','top'],['right','top'],['justify','top'],
        // 			['left','middle'],['center','middle'],['right','middle'],['justify','middle'],
        // 			['left','bottom'],['center','bottom'],['right','bottom'],['justify','bottom'],
        // 		]
        //         this.editStyles("align", alignText[data-1]);
        //         this.closeAlign();
        //     }else if(type === 'bullet'){
        //         this.editStyles("bullet", data-1);
        //         this.closeBullet();
        //     }else if(type === 'lineSpace'){
        //         let lineH = 0;
        //         if(data === 1){
        //             lineH = 1.0;
        //         }else if(data === 2){
        //             lineH = 1.2
        //         }else{
        //             lineH = data*0.5
        //         }
        //         this.editStyles("lineHeight", lineH);
        //         this.closeLineSpace();
        //     }
        //     if(this.isEditNote) this.$emit('addStack');
        // }
        toShow(type): void {
            this.$nextTick(() => {
                this.showState[type] = true;
            });
        }
        closeFamily(): void {
            this.showFamilyList = false;
        }
        closeSize(): void {
            this.showSizeList = false;
        }
        // get fontColor() {
        //     let color = this.$store.state.shape.fontFmt.color;
        //     if (color == null) {
        //         color = "#000000";
        //     }
        //     return color;
        // }
        showFontColor(e) {
            let node = e.target;
            let payload = {
                type: this.fmtType.font,
                index: 0,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "noteFontColor" });
            });
        }
        showBackColor(e) {
            let node = e.target;
            let payload = {
                type: this.fmtType.font,
                index: 1,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "noteFontColor" });
            });
        }

        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get actived() {
            return this.$store.state.shape.fontFmt.actived;
        }
        get isEditNote() {
            return this.from === "note";
        }
        get masked() {
            return !this.isEditNote && !this.actived;
        }
        get textAlign() {
            return this.$store.state.shape.fontFmt.align + 1;
        }
        get lineSpace() {
            let lineH = this.$store.state.shape.fontFmt.lineSpace;
            if (lineH === 1) {
                return 1;
            } else if (lineH === 1.2) {
                return 2;
            } else if (lineH % 0.5 === 0) {
                return lineH / 0.5;
            } else {
                return null;
            }
        }

        mounted() {
            if (this.lang == "zh") {
                this.family = this.zhFamily.concat(this.enFamily);
            } else {
                this.family = this.enFamily.concat(this.zhFamily);
            }
            document.addEventListener("selectionchange", this.getStyle);
        }
        beforeDestroy() {
            document.removeEventListener("selectionchange", this.getStyle);
        }
    }
</script>
<i18n>
{
  "zh": {
    "msgContent": "当前浏览器最小字号为",
    "msgContent2": ",请选择其他字号或修改浏览器设置"
  },
  "en": {
    "msgContent": "The minimum font size of the browser is",
    "msgContent2": ",Please select other font sizes or change the settings of your browser."
  },
  "jp": {
    "msgContent": "ブラウザの最小フォントサイズは",
    "msgContent2": "、別のフォントサイズを選択するか、ブラウザの設定を変更してください"
  },
  "fr": {
    "msgContent": "Taille de police minimale du navigateur est",
    "msgContent2": ",veuillez sélectionner d'autres tailles de police ou modifier les paramètres de votre navigateur"
  },
  "de": {
    "msgContent": "Mindestschriftgröße des Browsers beträgt",
    "msgContent2": "Bitte wählen Sie eine andere Schriftgrößen oder ändern Sie die Einstellungen Ihres Browsers."
  },
  "es": {
    "msgContent": "El tamaño mínimo de la fuente del navegador es",
    "msgContent2": "Por favor, seleccione otros tamaños de fuente o cambie la configuración de su navegador"
  },
  "pt": {
    "msgContent": "O tamanho mínimo da fonte do browser é",
    "msgContent2": ",Por favor, selecionar outros tamanhos de fonte ou alterar as configurações do seu browser."
  },
  "it": {
    "msgContent": "La dimensione minima dei caratteri è",
    "msgContent2": ". Si prega di selezionare una dimensione diversa o di modificare le impostazioni del browser."
  },
  "tw": {
    "msgContent": "當前瀏覽器最小字號為",
    "msgContent2": ",請選擇其他字號或修改瀏覽器設置"
  }
}
</i18n>
